import React from 'react';

export default function BookingPageHeader({ navigate }) {
  return (
    <div
      className="booking-page-header"
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        gap: '1rem',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginBottom: '1.2rem',
      }}
    >
      <div className="booking-page-header__copy">
        <h2
          style={{
            color: '#1ecfff',
            fontWeight: 800,
            fontSize: '1.5rem',
            margin: 0,
          }}
        >
          Book Flight
        </h2>

        <div
          style={{
            color: '#b6eaff',
            marginTop: '0.4rem',
            lineHeight: 1.4,
            fontSize: '0.95rem',
            maxWidth: 700,
          }}
        >
          Choose a date to view aircraft availability.
        </div>
      </div>

      <button
        className="booking-page-header__back"
        type="button"
        onClick={() => navigate('/dashboard')}
        style={{
          background: '#b6eaff',
          color: '#181a2a',
          border: 'none',
          borderRadius: 8,
          padding: '0.65rem 1rem',
          fontSize: '1rem',
          fontWeight: 700,
          cursor: 'pointer',
        }}
      >
        Back to Dashboard
      </button>
    </div>
  );
}